import { Injectable, Injector, Type } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
import { Store } from '@ngxs/store';
import { CURRENT_RECORD_STATE_TOKEN } from '@records/state/current-record/current-record-state.token';
import { EntityType } from '@shared/models/entity-enum';
import { ReactivePropertyTypeValidatorService } from '../custom/property/property-types/reactive-property-types-validator.service';
import { ControlConfigTuple, ControlValidatorPlugin } from '../models/control-validator-plugin';

const __GeneralFormValidatorEntityServiceSymbol = Symbol('__GeneralFormValidatorEntityService');

/**
 * This validator executes right after the form is created and connects the
 * form with the validator generator if any specific by entity is declared
 *
 */
@Injectable({
  providedIn: 'root',
})
export class GeneralFormValidatorEntityService implements ControlValidatorPlugin<DataObject> {
  private _generalValidatorByEntityMap = new Map<EntityType, Type<ControlValidatorPlugin<any>>>();
  constructor(
    private store: Store,
    private injector: Injector
  ) {
    // Property general/record validator
    this._generalValidatorByEntityMap.set(EntityType.Property, ReactivePropertyTypeValidatorService);
  }

  connect({ control: mainForm }: ControlConfigTuple<DataObject>): void {
    if (!mainForm[__GeneralFormValidatorEntityServiceSymbol]) {
      const currentRecord = this.store.selectSnapshot(CURRENT_RECORD_STATE_TOKEN);
      const entity = currentRecord.type as EntityType;
      const ControlValidatorPluginType = this._generalValidatorByEntityMap.get(entity);

      if (ControlValidatorPluginType != null) {
        const controlValidatorPluginInstance = this.injector.get(ControlValidatorPluginType);

        if (controlValidatorPluginInstance != null) {
          controlValidatorPluginInstance.connect({ control: mainForm });
        }
      }
    }
  }
}
